import { createEvent, createStore, sample } from "effector";

import { closeSession } from "@entities/session";

export const passwordExpired = createEvent();
export const resetPasswordExpired = createEvent();

export const $isPasswordExpired = createStore(false)
  .on(passwordExpired, () => true)
  .reset(resetPasswordExpired);

sample({
  clock: passwordExpired,
  target: closeSession,
});
